export default {
  cover: null,
  // work: null,
  works: null,
};
